__turbopack_context__.v({
  "container": "PlaceholderStores-module-scss-module__xPxnEa__container",
  "emptyState": "PlaceholderStores-module-scss-module__xPxnEa__emptyState",
  "findAStoreButton": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreButton",
  "findAStoreCard": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreCard",
  "findAStoreCta": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreCta",
  "findAStoreImage": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreImage",
  "findAStoreImagePlaceholder": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreImagePlaceholder",
  "findAStoreImageWrapper": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreImageWrapper",
  "findAStoreInfo": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreInfo",
  "findAStorePlaceholderIcon": "PlaceholderStores-module-scss-module__xPxnEa__findAStorePlaceholderIcon",
  "findAStoreText": "PlaceholderStores-module-scss-module__xPxnEa__findAStoreText",
  "headingWrapper": "PlaceholderStores-module-scss-module__xPxnEa__headingWrapper",
  "inner": "PlaceholderStores-module-scss-module__xPxnEa__inner",
  "slide": "PlaceholderStores-module-scss-module__xPxnEa__slide",
  "sliderWrapper": "PlaceholderStores-module-scss-module__xPxnEa__sliderWrapper",
  "swiper": "PlaceholderStores-module-scss-module__xPxnEa__swiper",
});
